import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { useCampaignCardContext } from '../../../campaign-card-context';
import { Badge, BadgeSize } from '@prisjakt/ui/badge';
import { parseUTCDate } from 'src/components/offer/price/offer-price/price-data';

export const Badges = () => {
  const { offerPrice } = useCampaignCardContext();
  const { market, t } = useAppContext();

  return (
    <>
      {offerPrice?.memberPrice && (
        <Badge
          color="YELLOW"
          size={BadgeSize.SMALL}
          text={t('product', 'promotions.members-price')}
        />
      )}

      {!offerPrice?.memberPrice && offerPrice?.originalPrice && (
        <Badge
          color="RED"
          size={BadgeSize.SMALL}
          text={
            offerPrice.endDate
              ? t('campaigns', 'campaign-card.sale-badge-end-date', {
                  date: parseUTCDate(offerPrice.endDate, market.localeStandard),
                })
              : t('campaigns', 'campaign-card.sale')
          }
        />
      )}
    </>
  );
};
